import * as React from 'react';

import {Button} from '@deviceinsight/ng-ui-basic-components';

import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import kpiIcon from '../../../../../assets/icon_data.svg';

type ButtonProps = {
	selectKpi: () => void;
	kpiName: string | null | undefined;
	disabled: boolean | null | undefined;
	'data-testid'?: string;
};

const SelectKpiButton = ({selectKpi, kpiName, disabled}: ButtonProps) => {
	const title = kpiName
		? kpiName
		: {
				id: 'dashboard.widgets.kpiaggredatedchart.config.selectkpi',
				defaultValue: 'Select KPI'
		  };
	const textAlign = kpiName ? 'left' : 'center';
	const label = kpiName ? (
		<span title={kpiName}>{kpiName}</span>
	) : (
		<span>
			<Trans i18nKey="dashboard.widgets.kpiaggredatedchart.config.selectkpi">Select KPI</Trans>
		</span>
	);
	return (
		<Button
			onClick={selectKpi}
			title={title}
			style={{
				textAlign
			}}
			disabled={!!disabled}
			data-testid="select-kpi-button">
			{kpiName && <img src={kpiIcon} alt="kpi" className="datasource-icon" />}
			{label}
		</Button>
	);
};

export default SelectKpiButton;
